export var TokenType;
(function (TokenType) {
    TokenType["synthetic"] = "synthetic";
    TokenType["syntheticRebase"] = "syntheticRebase";
    TokenType["fastSynthetic"] = "fastSynthetic";
    TokenType["syntheticUri"] = "syntheticUri";
    TokenType["collateral"] = "collateral";
    TokenType["collateralVault"] = "collateralVault";
    TokenType["collateralVaultRebase"] = "collateralVaultRebase";
    TokenType["XERC20"] = "xERC20";
    TokenType["XERC20Lockbox"] = "xERC20Lockbox";
    TokenType["collateralFiat"] = "collateralFiat";
    TokenType["fastCollateral"] = "fastCollateral";
    TokenType["collateralUri"] = "collateralUri";
    TokenType["native"] = "native";
    TokenType["nativeScaled"] = "nativeScaled";
})(TokenType || (TokenType = {}));
export const gasOverhead = (tokenType) => {
    switch (tokenType) {
        case TokenType.fastSynthetic:
        case TokenType.synthetic:
            return 64000;
        case TokenType.native:
            return 44000;
        default:
            return 68000;
    }
};
//# sourceMappingURL=config.js.map